import { render, staticRenderFns } from "./SaveAndProceedOrRefusePrompt.vue?vue&type=template&id=41af5cb6&"
import script from "./SaveAndProceedOrRefusePrompt.vue?vue&type=script&lang=js&"
export * from "./SaveAndProceedOrRefusePrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports